<template>
  <div class="map-container">
    <div id="container"></div>
    <div class="control-panel">
      <el-button-group>
        <el-button type="primary" size="small" @click="startAnimation" :disabled="isPlaying">开始回放</el-button>
        <el-button type="warning" size="small" @click="pauseAnimation" :disabled="!isPlaying">暂停</el-button>
        <el-button type="success" size="small" @click="resumeAnimation" :disabled="!isPaused">继续</el-button>
        <el-button type="danger" size="small" @click="stopAnimation">停止/重置</el-button>
      </el-button-group>
      <div class="speed-control">
        <span>速度: </span>
        <el-slider v-model="speed" :min="100" :max="5000" :step="100" show-input style="width: 200px; display: inline-block; vertical-align: middle; margin-left: 10px;"></el-slider>
      </div>
    </div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  name: "TrackMap",
  data() {
    return {
      AMap: null,
      map: null,
      marker: null,
      polyline: null,
      passedPolyline: null,
      path: [],
      isPlaying: false,
      isPaused: false,
      isStopped: false,
      speed: 1000
    }
  },
  mounted() {
    this.initAMap();
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
  },
  methods: {
    initAMap() {
      AMapLoader.load({
        key: "0826878f934aa6f773237d9c82dfcf45",
        version: '2.0',
        plugins: [
          "AMap.PolygonEditor",
          "AMap.MouseTool",
          'AMap.Scale',
          'AMap.MoveAnimation'
        ]
      }).then((AMap) => {
        this.AMap = AMap;
        this.map = new AMap.Map('container', {
          zoom: 15,
          center: [116.397428, 39.90923],
          viewMode: '3D'
        });

        this.map.addControl(new AMap.Scale());
        this.generateRandomPath();
        this.initTrack();
      }).catch((e) => {
        console.error(e);
      });
    },
    generateRandomPath() {
      const center = [116.397428, 39.90923];
      const path = [];
      path.push(center);

      let lng = center[0];
      let lat = center[1];

      for (let i = 0; i < 20; i++) {
        lng += (Math.random() - 0.5) * 0.01;
        lat += (Math.random() - 0.5) * 0.01;
        path.push([lng, lat]);
      }
      this.path = path;
    },
    initTrack() {
      if (!this.AMap || !this.map) return;

      this.polyline = new this.AMap.Polyline({
        map: this.map,
        path: this.path,
        showDir: true,
        strokeColor: "#28F",
        strokeOpacity: 0.8,
        strokeWeight: 6,
      });

      this.createPassedPolyline();

      this.marker = new this.AMap.Marker({
        map: this.map,
        position: this.path[0],
        content: '<img src="https://webapi.amap.com/images/car.png" style="width:52px; height:26px; transform: rotate(-90deg); display: block;">',
        offset: new this.AMap.Pixel(-26, -13),
        autoRotation: true,
      });

      if (this.path.length > 1) {
        const p1 = this.path[0];
        const p2 = this.path[1];
        const dx = p2[0] - p1[0];
        const dy = p2[1] - p1[1];
        const mathDeg = Math.atan2(dy, dx) * 180 / Math.PI;
        const amapAngle = 90 - mathDeg;
        this.marker.setAngle(amapAngle);
      }

      this.marker.on('moving', (e) => {
        if (this.isStopped) return;
        if (this.passedPolyline) {
          this.passedPolyline.setPath(e.passedPath);
        }
      });

      this.map.setFitView();
    },
    createPassedPolyline() {
      if (this.passedPolyline) {
        this.passedPolyline.setMap(null);
        this.passedPolyline = null;
      }

      this.passedPolyline = new this.AMap.Polyline({
        map: this.map,
        strokeColor: "#AF5",
        strokeOpacity: 1,
        strokeWeight: 6,
        path: []
      });
    },
    startAnimation() {
      if (!this.marker) return;

      if (this.isPaused) {
        this.resumeAnimation();
        return;
      }

      this.isPlaying = true;
      this.isPaused = false;
      this.isStopped = false;

      this.marker.moveAlong(this.path, {
        speed: this.speed,
        autoRotation: true,
      });

      this.marker.once('moveend', () => {
        if (!this.isStopped) {
          this.isPlaying = false;
          this.isPaused = false;
          this.$toast.success('回放结束');
        }
      });
    },
    pauseAnimation() {
      if (this.marker) {
        this.marker.pauseMove();
        this.isPaused = true;
        this.isPlaying = false;
      }
    },
    resumeAnimation() {
      if (this.marker) {
        this.marker.resumeMove();
        this.isPaused = false;
        this.isPlaying = true;
      }
    },
    stopAnimation() {
      if (this.marker) {
        this.isStopped = true;
        this.marker.stopMove();
        this.createPassedPolyline();
        this.marker.setPosition(this.path[0]);
        this.isPlaying = false;
        this.isPaused = false;

        if (this.path.length > 1) {
          const p1 = this.path[0];
          const p2 = this.path[1];
          const dx = p2[0] - p1[0];
          const dy = p2[1] - p1[1];
          const mathDeg = Math.atan2(dy, dx) * 180 / Math.PI;
          this.marker.setAngle(90 - mathDeg);
        }
      }
    }
  }
};
</script>

<style scoped>
.map-container {
  position: relative;
  width: 100%;
  height: 500px;
}

#container {
  width: 100%;
  height: 100%;
}

.control-panel {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;
  background: var(--surface-1);
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.speed-control {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
</style>
